import styled from 'styled-components';

export const RadioGroupFlexFieldWrapper = styled.div<{ error: string | boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 10px;
`;
